global.$ = require("jquery")
global.jQuery = global.$
global.moment = require('moment');

require('@fortawesome/fontawesome-free/js/all');

require('datatables.net')()
require('datatables.net-bs4')();
require('datatables.net-select-bs4')();
require('popper.js');
require('bootstrap');
require('chart.js');
require('tempusdominus-bootstrap-4');
require('select2')($);

require('./lang.fr.js');

// require('tinymce');
// require('tinymce/themes/modern/theme');

// Should we ever require Dropzone
global.Dropzone = require('dropzone');
Dropzone.autoDiscover = false;

function activateDropzone(dzone) {
    let id = dzone.attr('id');
    let dropzone = new Dropzone('#' + id,
        {
            'url': dzone.data('target'),
            'params': {
                'csrfmiddlewaretoken': dzone.data('csrfmiddlewaretoken'),
                'profile': dzone.data('profile'),
                'lab': dzone.data('lab')
            },
            'maxFilesize': 32000
        }
    );
    dropzone.on("success", function(file, response) {
        let input = $('input[name="dropzone_files"]');
        input.val(input.val() + response.fid + ',');
    });
}

// Inspiration: https://www.html5rocks.com/en/tutorials/file/dndfiles/
function handleFileSelect(event) {
    event.stopPropagation();
    event.preventDefault();

    var files = event.dataTransfer.files; // files is a FileList of File objects

    var reader = new FileReader();
    reader.onload = function(e) {
        var data = {};
        var text = reader.result;
        var lines = text.split('\n');
        lines.map(function(item) {
            var tabs = item.split('\t');
            data[tabs[0]] = tabs[1];
        });
        var out = JSON.stringify(data)
        // console.log(out);
        event.srcElement.value = out;
    };

    var file = files[0];
    reader.readAsText(file);
}

function handleDragOver(evt) {
    evt.stopPropagation();
    evt.preventDefault();
    evt.dataTransfer.dropEffect = 'copy'; // Explicitly show this is a copy.
}

$(function () {
    // Setup the dnd listeners.
    if (window.File && window.FileReader && window.FileList) {
        // Great success! All the File APIs are supported.
        var dropZone = document.getElementById('id_annotations');
        if (dropZone) {
            dropZone.addEventListener('dragover', handleDragOver, false);
            dropZone.addEventListener('drop', handleFileSelect, false);
        }
    } else {
        $(".no-file-api").addClass("d-none");
    }


    $.fn.datetimepicker.Constructor.Default.icons = {
        time: 'far fa-clock',
        date: 'far fa-calendar-alt',
        up: 'fas fa-arrow-up',
        down: 'fas fa-arrow-down',
        previous: 'fas fa-chevron-left',
        next: 'fas fa-chevron-right',
        today: 'far fa-calendar-check',
        clear: 'fas fa-trash-alt',
        close: 'fas fa-times'
    };

    if ('fr' == $("html").attr("lang")) {
        Dropzone.prototype.defaultOptions.dictDefaultMessage = lang.dropzone.dictDefaultMessage;
        Dropzone.prototype.defaultOptions.dictFallbackMessage = lang.dropzone.dictFallbackMessage;
        Dropzone.prototype.defaultOptions.dictFallbackText = lang.dropzone.dictFallbackText;
        Dropzone.prototype.defaultOptions.dictFileTooBig = lang.dropzone.dictFileTooBig;
        Dropzone.prototype.defaultOptions.dictInvalidFileType = lang.dropzone.dictInvalidFileType;
    };

    $(".input-group.datetimepicker").datetimepicker(
        {
            format: 'YYYY-MM-DD HH:mm',
            //debug:true, sideBySide: true,
            allowInputToggle: true
        });

    $(".input-group.datepicker").datetimepicker(
        {
            format: 'YYYY-MM-DD',
            // debug:true,
            allowInputToggle: true
        });

    $.extend( $.fn.dataTable.defaults, {
        order: [[ 0, "asc" ]],
        deferRender: true,
        lengthChange: false,
        bAutoWidth: false,
        pageLength: 25
    });

    $('[data-toggle="tooltip"]').tooltip();

    $('.dropzone.dynamic').each(function() {
        activateDropzone($(this));
    });

    $('#file-delete-modal').on('show.bs.modal', function (event) {
        let button = $(event.relatedTarget);
        let modal = $(this);
        $("#target-filename").html(button.data('filename'));
        $("#target-thumbnail").attr("src", button.data('img'));
        $("#file-delete-form").attr("action", button.data('action'));
    });

    $('#file-delete-modal-submit').click(function() {
        $("#file-delete-form").submit();
    });

    $("#lab-switch-form select#id_lab").change(function() {
        $("#lab-switch-form").submit();
    })

    $.fn.select2.defaults.set("minimumResultsForSearch", 20);
    $.fn.select2.defaults.set("theme", 'bootstrap4');
    $.fn.select2.defaults.set("tokenSeparators", [',', ' ']);

    $('form select.form-control').each(function() {
        $(this).select2();
    });

    $('body').on('click', '.close-card', function() {
        $(this).closest('.card-container').fadeOut();
        var table = $(this).closest("table")
        if (table.length) {
            var tr = $(this).closest("tr");
            var prev = tr.prev('tr');
            var row = table.DataTable().row(prev);
            var child = row.child
            if (child.isShown()) {
                child.hide();
            }
        }

    })

    $("body").on('click', '.details', function(event) {
        var container = $("#details-container")
        container.html('');
        container.load($(this).attr('href'));
        $('html, body').animate({ scrollTop: container.offset().top}, 750);
        return false; // event.stopPropagation() and event.preventDefault()
    });

    $("body").on('click', '.ds_details', function(event) {
        var container = $("#details-container")
        container.html('');
        container.load($(this).attr('href'), function() {
            $(this).find('table').DataTable({
                order: [[ 6, 'desc' ]],
                columnDefs: [
                    { orderable: false, targets: 0}
                ]
            });
        });
        $('html, body').animate({ scrollTop: container.offset().top}, 750);
        return false; // event.stopPropagation() and event.preventDefault()
    });

    $("body").on('click', 'button.datafile-details', function() {
        var b = $(this);
        var tr = b.closest("tr");
        var table = b.closest("table");
        var row = table.DataTable().row(tr);
        var child = row.child
        var url = b.data("url");
        if (child.isShown()) {
            child.hide();
        } else {
            $.get(
                url,
                function(data) {
                    child('<div class="py-3">' + data + '</div>').show()
                },
                'html'
            )
        }
    });
});
